import PageHeader from "@/components/PageHeader";
import PublicationIntelPanel from "@/components/PublicationIntelPanel";

export default function Inteligencja() {
  return (
    <div>
      <PageHeader
        title="Inteligencja publikacji"
        subtitle="Co działa w treściach, jak żyją w czasie i co nagrać w tym tygodniu"
      />
      <PublicationIntelPanel />
    </div>
  );
}
